import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ClubConfirmProvider } from './ClubConfirmProvider';

export default function ClubUiProviders({ children, rootId = 'club-root' }) {
    return (
        <div id={rootId} className="min-h-svh">
            <TooltipProvider delayDuration={0}>
                <ClubConfirmProvider
                    defaultOptions={{
                        cancellationText: 'Cancelar',
                        confirmationText: 'Confirmar',
                    }}
                >
                    {children}
                    <Toaster position="top-center" richColors closeButton />
                </ClubConfirmProvider>
            </TooltipProvider>
        </div>
    );
}
